export default __webpack_public_path__ + "static/media/pantry1-afterH-1024w.bd4c463e.webp";